import React, { useEffect, useRef, useState } from 'react';
import { sendGAEvent } from '../../../domain/marketing/gtm-provider';
import { IGdpr, setGDPRCookie, setGpcSessionCookie } from '../domain/gdpr-provider';
import { format } from 'date-fns';
import { getHiddenDataString, getIsAuthenticated } from '../../../domain/hidden-data-provider';
import { updateGDPR } from '../data/data-service';

const GA_EVENT_TITLE = 'Consent Widget';

interface IGDPRWidgetLawyerProps {
    isGpc: boolean;
}

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-4435
 */
const GDPRWidgetLawyer = ({ isGpc }: IGDPRWidgetLawyerProps) => {

    const popupRef = useRef<HTMLDivElement>(null);

    const [classes, setClasses] = useState('');
    const [isShown, setIsShown] = useState(true);

    useEffect(() => {
        const timer = window.setTimeout(() => {
            setClasses('opened');

            popupRef?.current?.focus();
        }, 1);

        return () => window.clearTimeout(timer);
    }, []);

    const readMoreGAEvent = () => {
        sendGAEvent(GA_EVENT_TITLE, 'Read More');
    };

    const customizeGAEvent = () => {
        sendGAEvent(GA_EVENT_TITLE, 'Customize');
    };

    const decline = async () => {
        const data: IGdpr = {
            IsMarketing: false,
            IsPerformance: false,
            IsFunctional: false,
            ItemModifiedWhen: format(new Date(),'MM/dd/yyyy HH:mm:ss'),
            IsCountryGDPR: getHiddenDataString('gdpr-country') || 'u',
        };

        setGDPRCookie(data);

        const isUserLoggedIn = getIsAuthenticated();
        if(isUserLoggedIn) {
            await updateGDPR(true);
        }

        sendGAEvent(GA_EVENT_TITLE, 'I Decline');
        setIsShown(false);

        if(isGpc) {
            setGpcSessionCookie();
        }
    };

    const agree = async () => {

        const data: IGdpr = {
            IsMarketing: true,
            IsPerformance: true,
            IsFunctional: true,
            ItemModifiedWhen: format(new Date(),'MM/dd/yyyy HH:mm:ss'),
            IsCountryGDPR: getHiddenDataString('gdpr-country') || 'u',
        };

        setGDPRCookie(data);

        const isUserLoggedIn = getIsAuthenticated();
        if(isUserLoggedIn) {
            await updateGDPR(true);
        }

        sendGAEvent(GA_EVENT_TITLE, 'I Agree');
        setIsShown(false);

        if(isGpc) {
            setGpcSessionCookie();
        }
    };

    /*const hide = () => {
        setIsShown(false);
    };*/

    return (
        <>
            {
                isShown &&
                <div id="slide-up-lawyer"
                     className={`fixed bottom-0 left-0 slide-up-lawyer max-w-full ${classes}`}
                     style={{
                         zIndex: 10002,
                         width: '800px',
                     }}>

                    <div
                        ref={ popupRef }
                        tabIndex={ -1 }
                        className="flex flex-col items-center justify-center text-center w-full py-6 px-4"
                        style={{
                            backgroundColor: '#EFFF00',
                            color: '#16151C'
                        }}>

                       {/* {
                            !isOptOut &&
                            <button
                                className="absolute right-0 top-0 mr-4 mt-4"
                                onClick={hide}
                                title="Close"
                                type="button">
                                <CloseIcon
                                    width="15px"
                                    color="#000"
                                    title="Close"
                                />
                            </button>
                        }*/}

                        <p className="waves-h3">Waves Cookie & Privacy Preferences</p>

                        <p>
                            We use cookies and similar technologies to support site functionality, analyse usage, and, with your permission where required, support advertising and related data uses. You can choose how these technologies are used by selecting your preferences below. For more details see our <a
                            href="/legal/cookie-notice-and-privacy-choices" className="text-black" onClick={ readMoreGAEvent }>Cookie Notice and Privacy Preferences</a>.
                        </p>

                        {/*{
                            isOptOut &&
                            <p>
                                We use cookies and similar technologies to enhance your browsing experience, serve
                                personalized ads
                                or content, and analyze our traffic.
                                By clicking "Accept All Cookies," you consent to our use of cookies as described in
                                our <a
                                href="/legal/cookie-notice-and-privacy-choices#customize" className="text-black" onClick={readMoreGAEvent}>Cookie
                                Policy</a>.
                            </p>
                        }

                        {
                            !isOptOut &&
                            <p>
                                We use cookies and similar technologies to enhance your browsing experience, serve personalized ads or content, and analyse our traffic, as described in our <a
                                href="/legal/cookie-notice-and-privacy-choices#customize" className="text-black" onClick={readMoreGAEvent}>Cookie
                                Policy</a>. You can opt-out of sharing your cookie data with third parties by clicking
                                “Essential Cookies Only”.
                            </p>
                        }*/}

                        <div className="flex flex-col md:flex-row justify-center mt-4 mb-10">
                            <a
                                href="/legal/cookie-notice-and-privacy-choices#customize"
                                onClick={customizeGAEvent}
                                className="w-btn-outline-black bg-transparent md:mr-4 mb-2 md:mb-0">
                                Manage Preferences
                            </a>

                            <button
                                onClick={decline}
                                className="w-btn-outline-black bg-transparent md:mr-4 mb-2 md:mb-0"
                                type="button">
                                Reject Non-Essential Technologies
                            </button>

                            <button
                                onClick={agree}
                                className="w-btn bg-black"
                                type="button">
                                Accept All Technologies
                            </button>
                        </div>

                        {
                            isGpc &&
                            <div>
                                Your browser has sent a privacy signal (Global Privacy Control). We have applied your opt-out of advertising-related technologies, including those that may constitute sale, sharing, or targeted advertising under applicable U.S. state law. You can change your preferences at any time <a
                                    href="/legal/cookie-notice-and-privacy-choices#customize"
                                    onClick={ customizeGAEvent }
                                    className="underline text-black">
                                    here
                                </a>.
                            </div>
                        }

                    </div>

                </div>
            }
        </>
    );
}

export default GDPRWidgetLawyer;